import { render, staticRenderFns } from "./ProtestVrtTransaction.vue?vue&type=template&id=eb1229fe&scoped=true"
import script from "./ProtestVrtTransaction.vue?vue&type=script&lang=js"
export * from "./ProtestVrtTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1229fe",
  null
  
)

export default component.exports